"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _classnames = _interopRequireDefault(require("classnames")),
    _ProgressSummary = _interopRequireDefault(require("./ProgressSummary")),
    _fileTypeIconMap = _interopRequireDefault(require("../../../../../common/constants/fileTypeIconMap")),
    _utils = require("../../../../../common/utils");

require("../styles/_upload-item.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var retryFile = (0, _memoizeOne["default"])(function (retry, assetId, organisationId) {
  return function (event) {
    var _event$target$files = (0, _slicedToArray2["default"])(event.target.files, 1),
        file = _event$target$files[0];

    return retry(assetId, organisationId, file);
  };
}),
    removeUploadItem = (0, _memoizeOne["default"])(function (remove, assetId) {
  return function () {
    return remove(assetId);
  };
}),
    UploadItem = function (_Component) {
  function UploadItem() {
    var _this;

    return (0, _classCallCheck2["default"])(this, UploadItem), _this = _super.call(this), _this.onMouseEnterHandler = function () {
      _this.setState({
        hover: !0
      });
    }, _this.onMouseLeaveHandler = function () {
      _this.setState({
        hover: !1
      });
    }, _this.state = {
      hover: !1
    }, _this;
  }

  (0, _inherits2["default"])(UploadItem, _Component);

  var _super = _createSuper(UploadItem);

  return (0, _createClass2["default"])(UploadItem, [{
    key: "render",
    value: function render() {
      var hover = this.state.hover,
          _this$props = this.props,
          filename = _this$props.filename,
          loadedPercent = _this$props.loadedPercent,
          loaded = _this$props.loaded,
          status = _this$props.status,
          totalSize = _this$props.totalSize,
          retry = _this$props.retry,
          remove = _this$props.remove,
          assetId = _this$props.assetId,
          organisationId = _this$props.organisationId,
          metaData = _this$props.metaData,
          percentage = loadedPercent || Math.floor(100 * (loaded / totalSize)),
          fileTypeIcon = _fileTypeIconMap["default"][(0, _utils.getTypeFromAsset)({
        metaData: metaData,
        filename: filename
      })];

      return _react["default"].createElement("div", {
        className: "upload-item",
        onMouseEnter: this.onMouseEnterHandler,
        onMouseLeave: this.onMouseLeaveHandler
      }, "error" === status && retry && assetId ? _react["default"].createElement("label", {
        htmlFor: assetId,
        className: "upload-item__reset-upload"
      }, _react["default"].createElement("input", {
        id: assetId,
        type: "file",
        onChange: retryFile(retry, assetId, organisationId)
      }), _react["default"].createElement(_uiKit.Icon, {
        name: "folder",
        color: "russian",
        size: 24
      })) : _react["default"].createElement(_uiKit.Image, {
        defaultImageIcon: fileTypeIcon,
        height: "40px",
        width: "40px",
        backgroundSize: "cover"
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])("upload-item__details", {
          "upload-item__details--no-progress": 0 === loaded && "error" !== status
        }, {
          "upload-item__details--error": "error" === status
        })
      }, _react["default"].createElement("p", null, filename), _react["default"].createElement(_ProgressSummary["default"], {
        loadedPercent: percentage,
        loaded: loaded,
        removeUploadItem: removeUploadItem(remove, assetId),
        hover: hover,
        total: totalSize,
        status: status
      })));
    }
  }]), UploadItem;
}(_react.Component),
    _default = UploadItem;

exports["default"] = _default;